import { Component, computed, inject, input, OnInit, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { MainState, ModalService, TranslationPipe, TranslationService } from '@cloud-and-service/portal-lib';
import { Store } from '@ngxs/store';
import { LanguageSelectorComponent } from 'src/app/components/language-selector/language-selector.component';
import { PasswordService } from 'src/app/services/password.service';

/**
 * Asks Business Central to e-mail a new activation link. Business Central answers OK whether or not
 * the username exists, and its text is shown in a popup.
 */
@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['../login/login.component.scss'],
  imports: [
    FormsModule,
    RouterLink,
    TranslationPipe,
    LanguageSelectorComponent,
  ],
})
export class ForgotPasswordComponent implements OnInit {
  private readonly passwordService = inject(PasswordService);
  private readonly modalService = inject(ModalService);
  private readonly store = inject(Store);
  private readonly translation = inject(TranslationService);

  readonly routePrefix = input<string | undefined>(undefined, { alias: 'forsyning' });

  readonly logo = this.store.selectSignal(MainState.logo);
  readonly title = this.store.selectSignal(MainState.title);

  readonly userName = signal('');
  readonly sent = signal(false);
  readonly sending = signal(false);

  readonly canSubmit = computed(() => this.userName().trim().length > 0 && !this.sending());
  readonly loginLink = computed(() => this.routePrefix() ? ['/', this.routePrefix(), 'login'] : ['/login']);

  ngOnInit(): void {
    this.modalService.closeAllModals();
  }

  async submit(): Promise<void> {
    const routePrefix = this.routePrefix();
    if (!this.canSubmit() || !routePrefix) {
      return;
    }

    this.sending.set(true);
    try {
      const result = await this.passwordService.forgotPassword(routePrefix, this.userName().trim());
      this.sent.set(true);
      // await this.modalService.info(result?.messageContent || this.translation.getTranslation('FORGOT_PASSWORD_SENT'));
    } catch (error) {
      this.modalService.error(String(error));
    } finally {
      this.sending.set(false);
    }
  }
}
